import { render, staticRenderFns } from "./ManufacturerTypeEditLayer.vue?vue&type=template&id=8248831e&scoped=true&"
import script from "./ManufacturerTypeEditLayer.vue?vue&type=script&lang=js&"
export * from "./ManufacturerTypeEditLayer.vue?vue&type=script&lang=js&"
import style0 from "./ManufacturerTypeEditLayer.vue?vue&type=style&index=0&id=8248831e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8248831e",
  null
  
)

export default component.exports